import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

import { BASE_URL, REF_DATA_BRANCH } from '../../../env';
import { GET, HEADERS, errorMsg } from '../../../utils';

export const getBranches = createAsyncThunk(
    'RefDataBranch/getBranches',
    // eslint-disable-next-line consistent-return
    async (data, { rejectWithValue }) => {
        try {
            const uri = `${BASE_URL}${REF_DATA_BRANCH}/npi=${data.npi}/sourcetypeid=${data.sourcetypeid}`;
            const config = {
                method: GET,
                url: uri,
                HEADERS
            };
            const response = await axios(config);
            return response.data;
        } catch (err) {
            errorMsg(err.message);
            return rejectWithValue(err);
        }
    }
);

export const branchesSlice = createSlice({
    name: 'RefDataBranch',
    initialState: {
        branches: [],
        status: null,
        error: null
    },
    reducers: {},
    extraReducers(builder) {
        builder
            .addCase(getBranches.pending, (state) => {
                return {
                    ...state,
                    status: 'loading',
                    error: null
                };
            })
            .addCase(getBranches.fulfilled, (state, action) => {
                return {
                    ...state,
                    branches: action.payload,
                    status: 'succeeded',
                    error: null
                };
            })
            .addCase(getBranches.rejected, (state, action) => {
                return {
                    ...state,
                    error: action.error,
                    status: 'failed'
                };
            });
    }
});

export default branchesSlice.reducer;
export const { branches, reducer } = branchesSlice;
